import Activities from '@/components/Activities'
import { getDocumentLogs } from '@/modules/Documents/services'
import { useParams } from 'react-router-dom'

const Audit = () => {
    const { documentID } = useParams()

    return (
        <div>
            <Activities
                queryKey={`documents.${documentID}.logs`}
                apiCall={(payload) =>
                    getDocumentLogs(Number(documentID), payload)
                }
            />
        </div>
    )
}

export default Audit
